import { lazy, Suspense, useEffect } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import Home from "./components/Pages/AForluz/Home/RenderHome";
import NotFoundRoute from "./components/Common/NotFound";

// LAZY IMPORTS - A FORLUZ
const Historia = lazy(() => import("./components/Pages/AForluz/Historia/Historia"));
const Missao = lazy(() => import("./components/Pages/AForluz/Missao/Missao"));
const OrganogramaPage = lazy(() => import("./components/Pages/AForluz/Organograma/OrganogramaPage"));
const Estatuto = lazy(() => import("./components/Pages/AForluz/Estatudo/Estatuto"));
const Numeros = lazy(() => import("./components/Pages/AForluz/Numeros/Numeros"));
const Conselhos = lazy(() => import("./components/Pages/AForluz/Conselhos/Conselhos"));
const Comite = lazy(() => import("./components/Pages/AForluz/Comite/Comite"));
const Area = lazy(() => import("./components/Pages/AForluz/Area/Area"));

// LAZY IMPORTS - ACONTECE NA FORLUZ
const NoticiasForluz = lazy(() => import("./components/Pages/AconteceNaForluz/Noticias"));
const NoticiaCompletaRender = lazy(() => import("./components/Pages/AconteceNaForluz/NoticiaCompletaRender"));
const Comunicados = lazy(() => import("./components/Pages/AconteceNaForluz/Comunicados"));
const Guia = lazy(() => import("./components/Pages/AconteceNaForluz/Guia"));
const Publicacoes = lazy(() => import("./components/Pages/AconteceNaForluz/Publicacoes"));
const RelatorioAnualDeInformacoes = lazy(() => import("./components/Pages/AconteceNaForluz/RelatorioAnualDeInformacoes"));
const CalendarioBeneficioParticipante = lazy(() => import("./components/Pages/AconteceNaForluz/CalendarioBeneficioParticipante"));
const ApresentacoesEspeciais = lazy(() => import("./components/Pages/AconteceNaForluz/ApresentacoesEspeciais"));

// LAZY IMPORTS - PLANO A
const PlanoADescricao = lazy(() => import("./components/Pages/Planos/Plano A/Descricao"));
const RegulamentoA = lazy(() => import("./components/Pages/Planos/Plano A/Regulamento"));
const RentabilidadeAPage = lazy(() => import("./components/Pages/Planos/Plano A/Rentabilidade"));
const AtuarialA = lazy(() => import("./components/Pages/Planos/Plano A/Atuarial"));

// LAZY IMPORTS - PLANO B
const PlanoBDescricao = lazy(() => import("./components/Pages/Planos/Plano B/Descricao"));
const RegulamentoB = lazy(() => import("./components/Pages/Planos/Plano B/Regulamento"));
const CartilhasPageB = lazy(() => import("./components/Pages/Planos/Plano B/Cartilhas"));
const RentabilidadeBPage = lazy(() => import("./components/Pages/Planos/Plano B/Rentabilidade"));
const AtuarialB = lazy(() => import("./components/Pages/Planos/Plano B/Atuarial"));

// LAZY IMPORTS - PLANO TAESAPREV
const PlanoTaesaprev = lazy(() => import("./components/Pages/Planos/Plano taesaprev/Descricao"));
const RegulamentoTaesa = lazy(() => import("./components/Pages/Planos/Plano taesaprev/Regulamento"));
const CartilhaTaesa = lazy(() => import("./components/Pages/Planos/Plano taesaprev/Cartilhas"));
const RentabilidadeTaesaPage = lazy(() => import("./components/Pages/Planos/Plano taesaprev/Rentabilidade"));
const AtuarialTaesa = lazy(() => import("./components/Pages/Planos/Plano taesaprev/Atuarial"));
const RelatorioPropositoEspecificoTaesa = lazy(() => import("./components/Pages/Planos/Plano taesaprev/PerfilInvestimento"));

// LAZY IMPORTS - INVESTIMENTOS
const PoliticaInvestimento = lazy(() => import("./components/Pages/Investimentos/PoliticaInvestimento"));
const DemostracoesPage = lazy(() => import("./components/Pages/Investimentos/Demostracoes"));
const Demostrativos = lazy(() => import("./components/Pages/Investimentos/Demostrativos"));
const DemostrativoInvestimento = lazy(() => import("./components/Pages/Investimentos/DemostrativoInvestimento"));
const PerfilInvestimento = lazy(() => import("./components/Pages/Investimentos/PerfilInvestimento"));
const CalculadoraPage = lazy(() => import("./components/Pages/Investimentos/Calculadora"));
const CalculadoraContribPage = lazy(() => import("./components/Pages/Investimentos/CalculadoraContrib"));

// LAZY IMPORTS - GOVERNANÇA
const Manual = lazy(() => import("./components/Pages/Governanca/Manual"));
const LavagemTerrorismo = lazy(() => import("./components/Pages/Governanca/LavagemTerrorismo"));
const CodigoConduta = lazy(() => import("./components/Pages/Governanca/CodigoConduta"));
const LGPD = lazy(() => import("./components/Pages/Governanca/LGPD"));
const Denuncias = lazy(() => import("./components/Pages/Governanca/Denuncias"));
const ProgramaCompliance = lazy(() => import("./components/Pages/Governanca/ProgramaDeCompliance"));

// LAZY IMPORTS - CONTATO
const FaleConosco = lazy(() => import("./components/Pages/Contato/FaleConosco"));
const Canais = lazy(() => import("./components/Pages/Contato/Canais"));
const PeruntasFrequentes = lazy(() => import("./components/Pages/Contato/PerguntasFrequentes"));
const AtracaoeSelecao = lazy(() => import("./components/Pages/Contato/AtracaoeSelecao"));
const NossasPraticas = lazy(() => import("./components/Pages/Contato/NossasPraticas"));

// LAZY IMPORTS - TRANSPARÊNCIA
const Acesso = lazy(() => import("./components/Pages/Transparencia/Acesso"));
const ExtratoTac = lazy(() => import("./components/Pages/Transparencia/ExtratoTAC"));
const RelatorioAnualTransparencia = lazy(() => import("./components/Pages/Transparencia/RelatorioAnual"));
const RelatorioCircunstanciado = lazy(() => import("./components/Pages/Transparencia/RelatorioCircunstanciado"));
const RelatorioPropositoEspecifico = lazy(() => import("./components/Pages/Transparencia/RelatorioPropositoEspecifico"));
const PlanoGestaoAdministrativa = lazy(() => import("./components/Pages/Transparencia/PlanoGestaoAdministrativa"));

// LAZY IMPORTS - OUTROS
const Emprestimos = lazy(() => import("./components/Pages/Emprestimos/Emprestimos"));
const Formularios = lazy(() => import("./components/Pages/Formularios"));
const ResultadoBusaca = lazy(() => import("./components/Pages/ResultadoBusca/"));
const GuestaoDeRiscaoPage = lazy(() => import("./components/Pages/GuestaoDeRiscao/GuestaoDeRiscoPage"));
const ViverMelhorPage = lazy(() => import("./components/Pages/ViverMelhor/ViverMelhorPage"));
const CentralFrame = lazy(() => import("./components/Pages/CentralDeAtendimento/CentralFrame"));
const CalculadoraDeduzirIR = lazy(() => import("./components/Pages/CalculadoraDeduzirIR"));
const AtualizarDados = lazy(() => import("./components/Common/AtualizarDados"));

const LoadingFallback = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    fontSize: '1.2rem',
    color: '#666'
  }}>
    <div>Carregando...</div>
  </div>
);

function App() {
  useEffect(() => { }, []);

  return (
    <>
      {/* <BoxChat /> */}
      <Router>
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/historia" element={<Historia />} />
            <Route path="/missao" element={<Missao />} />
            <Route path="/organograma" element={<OrganogramaPage />} />
            <Route path="/estatuto" element={<Estatuto />} />
            <Route path="/numeros" element={<Numeros />} />
            <Route path="/conselhos" element={<Conselhos />} />
            <Route path="/comite" element={<Comite />} />

            {/* ACONTECE NA FORLUZ */}
            <Route path="/noticias-internas/:id" element={<NoticiaCompletaRender />} />
            <Route path="acontece-na-forluz/publicacoes" element={<Publicacoes />} />
            <Route path="acontece-na-forluz/noticias" element={<NoticiasForluz />} />
            <Route path="acontece-na-forluz/comunicados" element={<Comunicados />} />
            <Route path="acontece-na-forluz/guia-participante" element={<Guia />} />
            <Route path="acontece-na-forluz/relatorio-anual-informacoes" element={<RelatorioAnualDeInformacoes />} />
            <Route path="acontece-na-forluz/beneficio-participante" element={<CalendarioBeneficioParticipante />} />
            <Route path="acontece-na-forluz/apresentacoes-especiais" element={<ApresentacoesEspeciais />} />

            <Route path="resultado-busca" element={<ResultadoBusaca />} />

            {/* PLANO A */}
            <Route path="PlanoA/plano-a" element={<PlanoADescricao />} />
            <Route path="PlanoA/plano-a-regulamento" element={<RegulamentoA />} />
            <Route path="PlanoA/plano-a-rentabilidades" element={<RentabilidadeAPage />} />
            <Route path="PlanoA/Demonstracao-Atuarial" element={<AtuarialA />} />

            {/* PLANO B */}
            <Route path="PlanoB/Demonstracao-Atuarial" element={<AtuarialB />} />
            <Route path="PlanoB/plano-b-descricao" element={<PlanoBDescricao />} />
            <Route path="PlanoB/plano-b-regulamento" element={<RegulamentoB />} />
            <Route path="PlanoB/plano-b-cartilha" element={<CartilhasPageB />} />
            <Route path="PlanoB/plano-b-rentabilidades" element={<RentabilidadeBPage />} />

            {/* PLANO TAESAPREV */}
            <Route path="PlanoTaesaprev/plano-taesaprev-descricao" element={<PlanoTaesaprev />} />
            <Route path="PlanoTaesaprev/plano-taesaprev-regulamento" element={<RegulamentoTaesa />} />
            <Route path="PlanoTaesaprev/plano-taesaprev-cartilha" element={<CartilhaTaesa />} />
            <Route path="PlanoTaesaprev/plano-taesaprev-rentabilidades" element={<RentabilidadeTaesaPage />} />
            <Route path="PlanoTaesaprev/Demonstracao-Atuarial" element={<AtuarialTaesa />} />
            <Route path="PlanoTaesaprev/perfil-de-investimento" element={<RelatorioPropositoEspecificoTaesa />} />

            {/* INVESTIMENTOS */}
            <Route path="Investimentos/politica-investimentos" element={<PoliticaInvestimento />} />
            <Route path="Investimentos/demonstracoes-financeiras" element={<DemostracoesPage />} />
            <Route path="Investimentos/demonstrativos-contabeis" element={<Demostrativos />} />
            <Route path="Investimentos/demonstrativos-de-investimentos" element={<DemostrativoInvestimento />} />
            <Route path="Investimentos/perfil-de-investimento" element={<PerfilInvestimento />} />
            <Route path="Investimentos/calculadora-de-aporte" element={<CalculadoraPage />} />
            <Route path="Investimentos/calculadora-de-contribuicao" element={<CalculadoraContribPage />} />

            {/* ÁREAS */}
            <Route path="/diretoria-executiva" element={<Area />} />
            <Route path="/conselho-deliberativo" element={<Area />} />
            <Route path="/gerencia-de-complience-e-governacao-fpr-co" element={<Area />} />
            <Route path="/conselho-fiscal" element={<Area />} />
            <Route path="/presidencia-fpr" element={<Area />} />
            <Route path="/consultoria-juridica-fpr-cj" element={<Area />} />
            <Route path="/gerencia-de-comunicacao-e-atendimento-fpr-ca" element={<Area />} />
            <Route path="/assessoria-de-risco-fpr-ri " element={<Area />} />
            <Route path="/diretoria-de-investimentos-e-controle-fic" element={<Area />} />
            <Route path="/gerencia-de-renda-variavel-de-macroalocação-fic-rv" element={<Area />} />
            <Route path="/gerencia-de-controladoria-e-financas-fic-cf" element={<Area />} />
            <Route path="/gestao-de-renda-fixa-imoveis-e-emprestimos-fic-rf" element={<Area />} />
            <Route path="/diretoria-de-seguridade-e-gestao-fsg" element={<Area />} />
            <Route path="/gerencia-de-atuaria-e-seguridade-fsg-ad" element={<Area />} />
            <Route path="/gerencia-de-tecnologia-da-informacao-fsg-ti" element={<Area />} />
            <Route path="/gerencia-de-recursos-humanos-e-administracao-fsg-ra" element={<Area />} />
            <Route path="/diretoria-de-relacoes-com-participantes-frp" element={<Area />} />

            {/* GOVERNANÇA */}
            <Route path="/Governanca/politica-gov-corporativa" element={<Manual />} />
            <Route path="/Governanca/politica-lavagem-terrorismo" element={<LavagemTerrorismo />} />
            <Route path="/Governanca/codigo-etica" element={<CodigoConduta />} />
            <Route path="/Governanca/lgpd" element={<LGPD />} />
            <Route path="/Governanca/canal-de-denuncia" element={<Denuncias />} />
            <Route path="/Governanca/programa-de-compliance" element={<ProgramaCompliance />} />

            {/* CONTATO */}
            <Route path="/Contato/fale-conosco" element={<FaleConosco />} />
            <Route path="/Contato/canais-atendimento" element={<Canais />} />
            <Route path="/Contato/perguntas-frequentes" element={<PeruntasFrequentes />} />
            <Route path="/Contato/trabalhe-conosco" element={<AtracaoeSelecao />} />
            <Route path="/Contato/nossas-praticas" element={<NossasPraticas />} />

            {/* OUTROS */}
            <Route path="emprestimos" element={<Emprestimos />} />
            <Route path="Transparencia/acesso-informacao" element={<Acesso />} />
            <Route path="Transparencia/extrato-tac" element={<ExtratoTac />} />
            <Route path="Transparencia/relatorio-anual-informacoes" element={<RelatorioAnualTransparencia />} />
            <Route path="formularios" element={<Formularios />} />
            <Route path="Transparencia/relatorio-circunstanciado" element={<RelatorioCircunstanciado />} />
            <Route path="Transparencia/relatorio-proposito-especifico" element={<RelatorioPropositoEspecifico />} />
            <Route path="Transparencia/plano-de-gestao-administrativa" element={<PlanoGestaoAdministrativa />} />
            <Route path="gestaoderisco" element={<GuestaoDeRiscaoPage />} />
            <Route path="/CentralDeAtendimento/central-atendimento" element={<CentralFrame />} />
            <Route path="ViverMelhor/para-viver-melhor" element={<ViverMelhorPage />} />
            <Route path="/Calculadora/calculadora-deduzir" element={<CalculadoraDeduzirIR />} />

            {/* DEFAULT */}
            <Route path="*" element={<NotFoundRoute />} />
            <Route path="/Atualizar-Dados" element={<AtualizarDados />} />
          </Routes>
        </Suspense>
      </Router>{" "}
    </>
  );
}

export default App;
